import { REPORTS_ENDPOINT } from "../config";
import { createInstance } from "./createInstance";
const instance = createInstance(REPORTS_ENDPOINT);
export default instance;
